import { render, staticRenderFns } from "./product-resource-helper-components-1-main-page.vue?vue&type=template&id=0e56c591&"
import script from "./product-resource-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
export * from "./product-resource-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
import style0 from "./product-resource-helper-components-1-main-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports